import { useLocalStorage, useSessionStorage } from '@vueuse/core';
import { STORAGE_KEYS } from '~/constants/auth';

/**
 * Persist the last login method (SSO `apiName` or the literal `'email'`) so
 * the login page can promote the user's most recent choice. localStorage,
 * per-browser, no cross-device sync — that would need a BE user-record field.
 *
 * SSO logins use `setPending` / `consumePending` (sessionStorage) to carry
 * the provider apiName across the OAuth redirect, since the BE doesn't
 * include the provider in the success-callback query. The pending value is
 * only promoted to last-used on confirmed callback success.
 */
export function useLastLoginMethod() {
	const stored = useLocalStorage<string | null>(STORAGE_KEYS.lastLoginMethod, null);
	const pending = useSessionStorage<string | null>(STORAGE_KEYS.pendingLoginMethod, null);

	return {
		get: (): string | null => stored.value,
		set: (method: string) => {
			stored.value = method;
		},
		setPending: (method?: string) => {
			pending.value = method ?? null;
		},
		consumePending: (): string | null => {
			const value = pending.value;
			pending.value = null;
			return value;
		},
	};
}
